import { render, staticRenderFns } from "./DialogGroup.vue?vue&type=template&id=2b163cee&scoped=true&"
import script from "./DialogGroup.vue?vue&type=script&lang=js&"
export * from "./DialogGroup.vue?vue&type=script&lang=js&"
import style0 from "./DialogGroup.vue?vue&type=style&index=0&id=2b163cee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b163cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b163cee')) {
      api.createRecord('2b163cee', component.options)
    } else {
      api.reload('2b163cee', component.options)
    }
    module.hot.accept("./DialogGroup.vue?vue&type=template&id=2b163cee&scoped=true&", function () {
      api.rerender('2b163cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/DialogGroup.vue"
export default component.exports